import {useQuery} from '@tanstack/react-query';
import {userApi} from '@/contexts/api-context';

export const useCurrentUserQuery = () => {
  const query = useQuery({
    queryKey: ['currentUser'],
    queryFn: async () => userApi.verifyUser(),
  });

  return query;
};
